<div class="archive-result">
  <ui-dataset-table
    [data]="archives()"
    [config]="tableConfig()"
    (rowAction)="onRowAction($event)"
    (loadMore)="loadMore()">
    <ng-template #nameWithStatusCell let-row="row">
      <div
        class="archive-name-with-status"
        [class.archive-row-highlighted]="isHighlighted(row)"
      >
        <span>{{ row.name }}</span>
        @if (statusIcon(row); as icon) {
          <span [class]="icon" [title]="statusLabel(row) | translate"></span>
        }
      </div>
    </ng-template>

    <ng-template #typeCell let-row>
      @if (row.videoFormat === ArchiveVideoFormat.TimelapseMP4) {
        {{ 'ARCHIVE.TABLE.TIMELAPSE' | translate }}
      } @else if (row.isClip) {
        {{ 'ARCHIVE.TABLE.CLIP' | translate }}
      } @else {
        {{ 'ARCHIVE.TABLE.ARCHIVE' | translate }}
      }
    </ng-template>

    <ng-template #cameraCell let-row>
      {{ row.cameraName || '—' }}
    </ng-template>

    <ng-template #sharedCell let-row>
      @if (row.isShared) {
        <span
          class="ui-icon-shared"
          [title]="'ARCHIVE.TABLE.SHARED_TOOLTIP' | translate">
        </span>
      } @else {
        —
      }
    </ng-template>

    <ng-template #statusCell let-row>
      @if (isTimelapseProcessing(row)) {
        <ui-preloader [diameter]="18" [color]="preloaderColor.gray" />
      } @else if (isProcessing(row)) {
        <div class="archive-status-progress">
          <mat-progress-bar mode="buffer" [title]="statusLabel(row) | translate" />
          <span>{{ row.progress || 0 }}%</span>
        </div>
      } @else {
        @if (statusIcon(row); as icon) {
          <span [class]="icon" [title]="statusLabel(row) | translate"></span>
        } @else {
          {{ statusLabel(row) | translate }}
        }
      }
    </ng-template>
  </ui-dataset-table>
</div>
